<template>
  <div>
    <cms-our-schools
      v-if="ourSchoolsSetUp"
      :theme="ourSchoolsOptions"
      :content="homepage.our_schools[id]"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';
import isEmpty from 'lodash/isEmpty';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);
const isThemePreview = computed(() => mainStore.isThemePreview);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const ourSchoolsOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: translationStore.getComponentTranslation('ourSchools'),
    globalThemeSettings: mainStore.getGlobalThemeSettings,
  };
});

const ourSchoolsSetUp = computed(() => !isEmpty(homepage.value?.our_schools?.[id.value]?.content));
</script>
